import React from 'react';

const NotFound = () => {
    return (
        <div>
            <h2>This page isn't found, 404</h2>
        </div>
    );
};

export default NotFound;